import { render } from "./language.vue?vue&type=template&id=43ca118e"
import script from "./language.vue?vue&type=script&lang=js"
export * from "./language.vue?vue&type=script&lang=js"

import "./language.vue?vue&type=style&index=0&id=43ca118e&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__